import pagesNames from "../../constants/pages-names";

const navList = [
    {
        buttonId : "button-our-esg-strategy",
        title : "Our ESG Strategy",
        path : pagesNames.starategy,
        submenu : {
            id : "submenu-our-esg-strategy",
            nextId : "submenu-our-comitments",
            title : "Our ESG Strategy",
            subtitle : "We’re playing a leading role mobilizing finance, to support an inclusive, diverse and just transition towards a more sustainable economy.",
            button : {
                text : "Read More",
                path : pagesNames.starategy,
            },
            list : [
                {
                    text : "Our Material Matters",
                    path : pagesNames.materials,
                },
                {
                    text : "Our Business Strategy with an ESG Focus",
                    path : pagesNames.business,
                },
                {
                    text : "Environmental",
                    path : pagesNames.environment,
                },
                {
                    text : "Social",
                    path : pagesNames.social,
                },
                {
                    text : "Governance",
                    path : pagesNames.governance,
                },
                {
                    text : "Risk Management",
                    path : pagesNames.risk,
                }
            ],
            image : {
                name : 'strategy.jpg',
                alt : "Arabian Woman"
            },
        },
    },
    {
        buttonId : "button-our-comitments",
        title : "Our Commitments",
        // path : `/${siteLinks.ourCommitments}`,
        path : pagesNames.commitments,
        submenu : {
            id : "submenu-our-comitments",
            nextId : "submenu-our-esg-journey",
            title : "Our Commitments",
            subtitle : "SAB is proud to participate in fulfilling the Kingdom’s Vision 2030 goals by committing near a quarter of our balance sheet to finance the sustainability transition",
            button : {
                text : "Read More",
                // path : `/${siteLinks.ourCommitments}`,
                path : pagesNames.commitments,
            },
            list : [
                {
                    text : "Transition to Net Zero",
                    path : pagesNames.transition,
                },
                {
                    text : "Energy and Emissions",
                    path : pagesNames.emissions,
                },
                {
                    text : "Saudi Green Initiative",
                    path : pagesNames.saudiGreen,
                },
                {
                    text : "Vision 2030",
                    path : pagesNames.vision,
                },
                {
                    text : "Sustainable Products and Services",
                    path : pagesNames.sustainableFinancing,
                },
            ],
            image : {
                name : "commitments.jpg",
                alt : "Our Commitments background"
            },
        },
    },
    {
        buttonId : "button-our-esg-journey",
        title : "Our ESG Journey",
        // path : `/${siteLinks.ourJourney}`,
        path : pagesNames.journey,
        submenu : {
            id : "submenu-our-esg-journey",
            title : "Our ESG Journey",
            subtitle : "We’re doing this by embedding ESG at the heart of our organisation and our businesses, and leveraging our HSBC partnership.",
            button : {
                text : "Read More",
                // path : `/${siteLinks.ourJourney}`,
                path : pagesNames.journey,
            },
            list : [
                {
                    text : "2023 Highlights",
                    path : pagesNames.highlight,
                },
                {
                    text : "Embedding ESG throughout SAB",
                    path : pagesNames.embedding,
                },
                {
                    text : "International Frameworks",
                    path : pagesNames.frameworks,
                },
                {
                    text : "Listening to Our Stakeholders",
                    path : pagesNames.stakeholders,
                },
            ],
            image : {
                name : "journey.jpg",
                alt : "Journey page menu image"
            },
        },
    },
    {
        buttoPId : "button-news",
        title : "News",
        // path : `/${siteLinks.news}`,
        path : pagesNames.news,
        submenu : null,
    },
    {
        buttonId : "button-insights",
        title : "Insights",
        // path : `/${siteLinks.insights}`,
        path : pagesNames.insight,
        submenu : null,
    },
    {
        buttonId : "button-statements-and-plicies",
        title : "Statements and Policies",
        id : "submenu-statements-and-plicies",
        // path : `/${siteLinks.statements}`,
        path : pagesNames.statements,
        submenu : {
            title : "Statements and Policies",
            subtitle : "Our organisation recognizes the importance of addressing sustainability, environmental, social, and governance (ESG) issues, which are of great interest to our customers, clients, investors, and other stakeholders. To ensure consistent governance on these matters, we have established a set of policies and statements of intent that apply across our organisation, which are detailed on this page.",
            button : {
                text : "Read More",
                // path : `/${siteLinks.statements}`,
                path : pagesNames.statements,
            },
            list : [
                // {
                //     text : "CSR Policy",
                //     path : pagesNames.csr,
                // },
                // {
                //     text : "Compliance with Regulations",
                //     path : pagesNames.compliance,
                // },
                // {
                //     text : "Risk Documents",
                //     path : pagesNames.risk,
                // },
                // {
                //     text : "Internal Audit",
                //     path : pagesNames.home,
                // },
                // {
                //     text : "Governance And Financial Crime Statements",
                //     path : pagesNames.home,
                // },
                // {
                //     text : "Codes of Conduct",
                //     path : pagesNames.home,
                // },
            ],
            image : {
                name : "statements.jpg",
                alt : "Statements and Polices menu wallpaper"
            },
        },
    },
    {
        buttonId : "button-esg-resource-hub",
        title : "ESG Resource hub",
        // path : `/${siteLinks.resource}`,
        path : pagesNames.resource,
        submenu : {
            id : "submenu-esg-resource-hub",
            title : "ESG Resource hub",
            subtitle : "As reporting standards evolve and are implemented globally, we remain dedicated to adapting our approach to ESG disclosures in accordance with regulatory guidelines and industry norms.",
            button : {
                text : "Read More",
                // path : `/${siteLinks.resource}`,
                path : pagesNames.resource,
            },
            list : [
                {
                    text : "Reports",
                    path : pagesNames.reports,
                },
                {
                    text : "ESG Profile",
                    path : pagesNames.esgProfile,
                },
            ],
            image : {
                name : "resource.jpg",
                alt : "ESG Resource hub wallpaper",
            },
        },
    },
]

export default navList;